<template>
  <NuxtLayout name="default">
    <div class="news-container">
      <div class="kind">
        <div class="industry_container">
          <!-- 使用计算属性限制行业类别显示数量 -->
          <div
            v-for="(item, idx) in limitedIndustry"
            :key="item.industryId"
            class="item">
            <div class="item_inner">
              <div
                v-if="item.icon"
                class="industry-icon">
                <img
                  :src="item.icon"
                  :alt="item.industryName"
                  loading="lazy" />
              </div>
              <div class="item_value">
                <p>{{ formatIndustry(item.industryName) }}</p>
              </div>
            </div>
            <span class="arrow"></span>
            <div
              class="hover_content"
              :style="subIndustry(idx)">
              <nuxt-link
                v-for="two in item.children"
                :key="two.id"
                :to="`/information-1-${two.id}-1/`"
                target="_blank"
                class="hover_content_item"
                :class="two.id === industryId ? 'active-industry' : ''" prefetch-on="interaction">
                {{ two.industryName }}
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="Number(industryId) === 0 && pageNum === 1"
        class="new-news-container">
        <div class="new-news-top">
          <div class="new-news-top-left">
            <!-- 顶部新闻限制数量 -->
            <div
              v-for="item in news.slice(0, 3)"
              :key="item.newsId"
              class="top-item">
              <nuxt-link
                :to="handleNewsUrl(item.viewUrl, item.newsId)"
                :title="item.newsName"
                target="_blank" prefetch-on="interaction">
                <div class="news-name news-name__line1">
                  {{ item.newsName }}
                </div>
              </nuxt-link>
              <div class="news-other">
                <nuxt-link
                  :to="`/information-1-${$get(item, 'industryId[0]', 0)}-1/`"
                  :title="item.industryName + '资讯'"
                  target="_blank" prefetch-on="interaction">
                  <div class="news-industry">
                    {{ item.industryName }}
                  </div>
                </nuxt-link>
                <time class="news-publish-time">
                  {{ item.createTime }}
                </time>
              </div>
            </div>
          </div>
          <div class="new-news-top-middle">
            <el-carousel
              height="230px"
              indicator-position="none">
              <el-carousel-item
                v-for="item in news.slice(5, 10)"
                :key="item.newsId">
                <div class="news_img">
                  <nuxt-link
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    :title="item.newsName"
                    target="_blank" prefetch-on="interaction">
                    <img
                      :src="item.logo"
                      :alt="item.newsName"
                      loading="lazy" />
                  </nuxt-link>
                  <div class="news-name__middle">{{ item.newsName }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="new-news-top-right">
            <div
              v-for="item in news.slice(3, 8)"
              :key="item.newsId"
              class="top-item">
              <nuxt-link
                :to="handleNewsUrl(item.viewUrl, item.newsId)"
                :title="item.newsName"
                target="_blank" prefetch-on="interaction">
                <div class="news-name news-name__line1">
                  {{ item.newsName }}
                </div>
              </nuxt-link>
            </div>
          </div>
        </div>
        <div class="new-news-bottom">
          <!-- 限制底部新闻数量，避免渲染过多项目 -->
          <div
            v-for="item in news.slice(0, 5)"
            :key="item.newsId"
            class="bottom-item">
            <div class="news_img">
              <nuxt-link
                :to="handleNewsUrl(item.viewUrl, item.newsId)"
                :title="item.newsName"
                target="_blank" prefetch-on="interaction">
                <img
                  :src="item.logo"
                  :alt="item.newsName"
                  loading="lazy" />
              </nuxt-link>
            </div>
            <nuxt-link
              :to="`/information-1-${$get(item, 'industryId[0]', 0)}-1/`"
              :title="item.industryName + $t('news.information')"
              target="_blank" prefetch-on="interaction">
              <div class="news-industry">{{ item.industryName }}</div>
            </nuxt-link>
            <nuxt-link
              :to="handleNewsUrl(item.viewUrl, item.newsId)"
              :title="item.newsName"
              target="_blank" prefetch-on="interaction">
              <div class="news-name news-name__line2">{{ item.newsName }}</div>
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="news-main">
        <div class="news-left">
          <FairNews
            :total="newsTotal"
            :page-num="pageNum"
            :page-size="pageSize"
            :news="Number(industryId) > 0 || pageNum > 1 ? news : secondNews"
            :news-type="+newsType"
            :showType="Number(industryId) > 0 || pageNum > 1"
            :industry-id="+industryId" />
        </div>

        <div class="news-right">
          <div class="aside-section">
            <div class="aside-header">
              <SectionTitle
                :title="$t('news.latestExhibition')"
                style="font-size: 18px" />
              <span class="more">
                <a :href="`/exhibition-0-0-1-0-0-0-1/`">
                  {{ $t('common.more') }}&gt;
                </a>
              </span>
            </div>
            <!-- 使用计算属性限制展会数量显示 -->
            <fair-item
              v-for="item in limitedFair"
              :key="item.exhibitionId"
              :item="item" />
          </div>

          <div class="aside-section">
            <div class="aside-header">
              <SectionTitle
                :title="$t('news.latestNews')"
                style="font-size: 18px" />
              <span class="more">
                <nuxt-link :to="`/information/`" prefetch-on="interaction">{{ $t('common.more') }}&gt;</nuxt-link>
              </span>
            </div>
            <div class="news-list">
              <!-- 右侧新闻列表限制显示数量 -->
              <div
                v-for="item in news.slice(0, 6)"
                :key="item.newsId"
                class="news-item">
                <div class="news-cover">
                  <nuxt-link
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    :title="item.newsName"
                    target="_blank" prefetch-on="interaction">
                    <img
                      :src="getWebp(item.logo)"
                      :alt="item.newsName"
                      loading="lazy" />
                  </nuxt-link>
                </div>
                <div class="news-info">
                  <div class="news-name">
                    <nuxt-link
                      :to="handleNewsUrl(item.viewUrl, item.newsId)"
                      :title="item.newsName"
                      target="_blank" prefetch-on="interaction">
                      {{ item.newsName }}
                    </nuxt-link>
                  </div>
                  <div class="news-time">
                    {{ item.createTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import { checkDevice, handleNewsUrl,getWebp } from '~/utils/common'
  import { useNews } from '~/composables/news/useNews'
  import { ELocale } from '~~/types/enums'
  // 直接导入常用组件，避免异步加载开销
  import SectionTitle from '~/components/SectionTitle/index.vue'
  import FairNews from '../components/News.vue'
  import FairItem from '~/pages/home/components/FairItem.vue'

  const route = useRoute()

  // 生命周期
  onMounted(() => {
    if (checkDevice() == 'h5') {
      let url = `https://m.jufair.com/information`
      // window.location.replace(url)
    }
  })

  

  // 组件销毁时清理内存
  onUnmounted(() => {
    // 清理大数据引用，帮助垃圾回收
  })

  const {
    industry,
    news,
    secondNews,
    newsTotal,
    fair,
    tags,
    newsType,
    industryId,
    formatIndustry,
    subIndustry,
    pageNum,
    pageSize,
    handleClick,
    $get,
    $t
  } = await useNews(ELocale.cn)

  // 优化数据切片，减少渲染压力
  const limitedIndustry = (() => industry?.slice(0, 20) || [])()
  const limitedFair = (() => fair?.slice(0, 10) || [])()
  const limitedNews = (() => news?.slice(0, 30) || [])()

  // 缓存行业名称查找，避免重复计算
  const currentIndustryName = (() => {
    if (!industry?.length || !industryId || industryId === '0') {
      return ''
    }
    
    for (const industryItem of industry) {
      if (industryItem.children) {
        const found = industryItem.children.find((child: any) => child.id === +industryId)
        if (found) {
          return found.industryName
        }
      }
    }
    return ''
  })()

  // 缓存页面元数据
  const pageMetaData = (() => {
    const currentYear = new Date().getFullYear()
    const industryName = currentIndustryName
    const pageNumber = pageNum > 1 ? `_第${pageNum}页` : ''
    
    if (industryId && industryId !== '0' && industryName) {
      return {
        title: `最新${industryName}展新闻_${industryName}展最新消息-聚展`,
        keywords: `${industryName}展新闻,${industryName}展最新消息,${industryName}展报道`,
        description: `聚展网是国内专业国际展会一站式服务平台,提供最新最全的${currentYear}年${industryName}展咨询,${industryName}展新闻报道,${industryName}展出行攻略,${industryName}展搭建资讯,全球展会信息平台,国外展会信息,免费咨询都是在聚展网`
      }
    }
    
    return {
      title: `展会资讯_新闻_攻略_报道${pageNumber}-聚展`,
      keywords: '',
      description: `聚展网是国内专业国际展会一站式服务平台,提供最新最全的${currentYear}年国际展会咨询,新闻报道,出行攻略,搭建资讯,全球展会信息平台,国外展会信息,免费咨询。`
    }
  })()

  // Head - 使用缓存的计算属性
  useHead(() => {
    const { title, keywords, description } = pageMetaData
    
    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: keywords
        },
        {
          name: 'description',
          content: description
        },
        {
          name: 'og:type',
          content: 'webpage'
        },
        {
          name: 'og:url',
          content: `https://www.jufair.com${route.fullPath}`
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:image',
          content: 'https://www.jufair.com/logo.png'
        },
        {
          name: 'og:description',
          content: description
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: `https://www.jufair.com/information-${newsType}-${industryId}-1/`
        }
      ]
    }
  })
</script>

<style lang="less" scoped>
  .news-container {
    display: flex;
    flex-direction: column;
    width: 1190px;
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 22px;
    .news-name__line1,
    .news-name__line2,
    .news-name__line3 {
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .news-name__line1 {
      -webkit-line-clamp: 1;
    }
    .news-name__line2 {
      -webkit-line-clamp: 2;
    }

    .news-name__line3 {
      -webkit-line-clamp: 3;
    }

    .kind {
      width: 1190px;
      background: #fff;
      border-radius: 10px;
      left: calc(50% - 595px);
      padding: 20px 28px 0;
      margin-bottom: 12px;

      .industry_container {
        padding: 0;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 97px;
          display: flex;
          margin-right: 48px;
          padding-bottom: 20px;
          flex-flow: column;
          position: relative;

          .arrow {
            display: none;
            position: absolute;
            top: 10px;
            left: calc(50% - 7px);
            width: 0;
            height: 0;
            border: 7px solid;
            border-color: transparent transparent #ddd;
          }

          &:hover {
            .hover_content {
              display: flex;
              flex-flow: wrap;
            }

            .arrow {
              display: block;
            }
          }

          .item_inner {
            display: flex;

            &:hover {
              cursor: pointer;
            }
          }

          &:nth-child(8n) {
            margin-right: 0;
          }

          .industry-icon {
            width: 19px;
            height: 20px;
            margin-right: 6px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: auto;
              max-width: 19px;
              height: 20px;
            }
          }

          .item_value {
            font-size: 16px;
            color: #333;

            p {
              width: 110px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .hover_content {
            position: absolute;
            width: 558px;
            top: 25px;
            z-index: 10;
            display: none;
            padding: 16px 24px 0;
            background: #fff;
            box-shadow:
              0 4px 4px rgba(10, 16, 20, 0.12),
              0 0 4px rgba(10, 16, 20, 0.12);
            border-radius: 6px;
            box-sizing: border-box;

            .hover_content_item {
              min-width: 60px;
              // white-space: nowrap;
              // text-overflow: ellipsis;
              // overflow: hidden;
              font-size: 15px;
              margin-right: 15px;
              margin-bottom: 16px;

              &:nth-child(7n) {
                margin-right: 0;
              }

              &:hover {
                color: #e50113;
              }
            }

            .active-industry {
              color: #e50113;
              font-weight: 700;
            }
          }
        }
      }
    }

    .new-news {
      &-top {
        display: flex;

        .top-item {
          padding: 10px 0;
          border-bottom: solid 1px #dcdcdc;
          margin-bottom: -1px;

          &:last-child {
            border-bottom: none;
          }

          .news-name {
            font-size: 22px;
            color: #000;
            font-weight: 700;
            text-align: justify;
            line-height: 1.5;

            &:hover {
              color: @app-color;
            }
          }

          .news-other {
            display: flex;
            color: #9b9b9b;
            font-size: 12px;
            padding: 2px 0;
            line-height: 21px;

            .news-industry {
              margin-right: 0.5em;
            }
          }
        }

        &-left {
          width: 375px;
        }

        &-middle {
          width: 380px;
          margin: 0 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .news_img {
            width: 380px;
            height: 230px;
            border-radius: 4px;
            margin-right: 22px;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            position: relative;

            img {
              width: 380px;
              height: auto;
            }

            .news-name__middle {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              padding: 4px;
              background: rgba(0, 0, 0, 0.65);
              color: #fff;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }

        &-right {
          width: 375px;

          .top-item {
            .news-name {
              font-size: 20px;
              font-weight: 400;
            }
          }
        }
      }

      &-bottom {
        display: flex;
        margin: 30px 0 24px;

        .bottom-item {
          width: 214px;
          margin-right: 30px;

          &:last-child {
            margin-right: 0;
          }

          .news_img {
            width: 214px;
            height: 136px;
            border-radius: 4px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 214px;
              border-radius: 4px;
            }
          }

          .news-industry {
            color: @app-color;
            margin: 6px 0;
            font-size: 14px;
          }

          .news-name {
            color: #4a4a4a;
            font-size: 16px;
            text-align: justify;
          }
        }
      }
    }

    .news-main {
      display: flex;

      .news-left {
        border-radius: 6px;
        flex: 1;
        padding: 0;
      }

      .news-right {
        width: 362px;
        margin-left: 30px;

        .aside-section {
          margin-bottom: 12px;
        }

        .aside-header {
          padding: 0 0 12px 0;
          display: flex;
          justify-content: space-between;
          align-items: baseline;

          .more {
            font-size: 14px;
          }
        }

        .news-list {
          .news-item {
            display: flex;
            background: #fff;
            margin-bottom: 8px;
            box-sizing: border-box;
            padding: 12px;
            border-radius: 4px;

            .news-cover {
              width: 108px;
              height: 70px;
              margin-right: 12px;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              flex-shrink: 0;

              img {
                width: 108px;
                height: auto;
              }
            }

            .news-info {
              width: calc(100% - 120px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .news-name {
                word-break: break-all;
                text-align: justify;
                font-size: 14px;
                overflow: hidden; //将超出的部分隐藏
                text-overflow: ellipsis; //超出部分用省略号显示
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }

              .news-time {
                color: #666;
                font-family: 'Helvetica Neue', Helvetica, sans-serif;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
</style>
